import { Button, ButtonGroup, Grid, Typography } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import { Alert, AlertTitle } from '@material-ui/lab';
import { PDFDocumentProxy } from 'pdfjs-dist';
import { FunctionComponent, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { Props } from 'react-pdf/dist/Document';
import { SizeMe } from 'react-sizeme';
import { LoadingButton } from './LodingButton';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;


type PdfViewerProps = {
    downloadFileName?: string,
    onDocumentLoadSuccess?: (pdf: PDFDocumentProxy) => void,
    onDocumentLoadError?: (error: Error) => void,
    showDigitalCertDeclaration?: boolean
} & Omit<Props, "onLoadSuccess" | "onLoadError">

export const PdfViewer: FunctionComponent<PdfViewerProps> = ({ file, downloadFileName, onDocumentLoadSuccess: onDocumentLoadSuccessCb, onDocumentLoadError: onDocumentLoadErrorCb, showDigitalCertDeclaration, ...props }) => {
    const [numPages, setNumPages] = useState<number | null>(null);
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [rawData, setRawData] = useState<Uint8Array | null>(null);
    // const [rawDataLoaded, setRawDataLoaded] = useState<boolean>(false);
    const [state, setState] = useState<"loading" | "error" | "success">("loading");

    //@ts-expect-error
    async function onDocumentLoadSuccess(props) {
        setNumPages(props.numPages);
        setPageNumber(1);
        props.getData().then((d: Uint8Array) => { setRawData(d); setState("success") })
        if (!!onDocumentLoadSuccessCb) {
            onDocumentLoadSuccessCb(props)
        }
    }

    function onDocumentLoadError(error: Error) {
        setNumPages(null);
        setRawData(null);
        setState("error");
        if (!!onDocumentLoadErrorCb) {
            onDocumentLoadErrorCb(error)
        }
    }

    function downloadPdf() {
        let blob = new Blob([(rawData as Uint8Array).buffer], { type: 'application/pdf' });
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = downloadFileName || 'download.pdf';
        a.click();
    }

    function changePage(offset: number) {
        setPageNumber(prevPageNumber => prevPageNumber + offset);
    }

    function previousPage() {
        changePage(-1);
    }

    function nextPage() {
        changePage(1);
    }

    return (
        <Grid
            container direction="column"
            justify="space-around"
            alignItems="stretch"
        >
            <Grid container item
                direction="row"
                justify="space-between"
                alignItems="center">

                <Grid item>
                    <Button
                        type="button"
                        variant="outlined"
                        disabled={pageNumber <= 1 || state !== "success"}
                        onClick={previousPage}
                    >
                        Previous (আগে)
                    </Button>
                </Grid>
                <Grid item>
                    <Typography>Page {pageNumber || (numPages ? 1 : '--')} of {numPages || '--'}</Typography>
                </Grid>
                <Grid item>
                    <ButtonGroup>
                        <LoadingButton disabled={state === "error" || rawData == null} loading={state === "loading"} onClick={() => downloadPdf()} type="button" color="primary" variant="contained" startIcon={<GetAppIcon />}>Download (ডাউনলোড)</LoadingButton>
                        <Button
                            type="button"
                            //@ts-expect-error
                            disabled={pageNumber >= numPages || state !== "success"}
                            onClick={nextPage}
                        >
                            Next (পরবর্তী)
                        </Button>
                    </ButtonGroup>
                </Grid>
            </Grid>
            {
                showDigitalCertDeclaration &&
                <Grid
                    container item
                    direction="row"
                    justify="space-between"
                    alignItems="center"
                >
                    <Alert severity="info" style={{ textAlign: "justify" }}>
                        <AlertTitle>
                            Note
                        </AlertTitle>
                        <p>To validate a digital signature, you must use Adobe PDF software, such as Adobe Acrobat Reader (Desktop). PDF viewers such as Apple's Preview or Chrome’s PDF Viewer cannot be used.</p>
                    </Alert>
                </Grid>
            }
            <Grid item container
                direction="row"
                justify="center"
                alignItems="stretch"
            >
                <Grid item style={{ width: "100%" }}>

                    <SizeMe
                        monitorHeight
                        refreshRate={128}
                        // refreshMode={"debounce"}
                        //@ts-expect-error
                        render={({ size }) => (
                            <Document
                                {...props}
                                file={file}
                                onLoadSuccess={onDocumentLoadSuccess}
                                onLoadError={onDocumentLoadError}
                            >
                                <Page width={size.width} pageNumber={pageNumber} />
                            </Document>
                        )}
                    />
                </Grid>
            </Grid>
        </Grid>
    )
}